import { useEffect } from 'react';

export const useCaptureFbClid = (eventId) => {
    useEffect(() => {
        if (!window || !eventId) return;
        const params = new URLSearchParams(window.location.search);
        const fbClick = params.get('fbclid');

        if (fbClick) {
            localStorage.setItem(`fbclid-${eventId}`, fbClick);
        }
    }, [eventId]);
};

export const getFbClickFromStorage = (eventId) => {
    return localStorage.getItem(`fbclid-${eventId}`);
};
